import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'
import Tile from '@divvy-web/skylab.tile'
import Tooltip from '@divvy-web/skylab.tooltip'

import ImageWrapper from '@sputnik/components/ImageWrapper'

import styles from './styles.module.scss'

export interface BankAccountConnectionChoiceProps {
  title: string
  subtitle: string
  image: {
    name: string
    alt: string
  }
  action: {
    text: string
    onClick: () => void
    isDisabled?: boolean
    disabledTooltipText?: string
  }
}

const BankAccountConnectionChoice = ({
  title,
  subtitle,
  image: { alt, name },
  action: { text, onClick, isDisabled, disabledTooltipText },
}: BankAccountConnectionChoiceProps) => {
  const [getClassName] = useNameFormatter('BankAccountConnectionChoice')

  return (
    <Tile>
      <div className={styles[getClassName('')]}>
        <div className={styles[getClassName('text-wrapper')]}>
          <div className={styles[getClassName('title')]}>{title}</div>
          <div className={styles[getClassName('subtitle')]}>{subtitle}</div>
        </div>
        <div className={styles[getClassName('image-and-button-wrapper')]}>
          <ImageWrapper
            alt={alt}
            imageName={name}
          />
          <Tooltip
            disableTooltip={!!disabledTooltipText && !isDisabled}
            html={disabledTooltipText}
          >
            <BasicButton
              disabled={isDisabled}
              type={BASIC_BUTTON_TYPE_OUTLINED}
              onClick={onClick}
            >
              {text}
            </BasicButton>
          </Tooltip>
        </div>
      </div>
    </Tile>
  )
}

export default BankAccountConnectionChoice
